import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Image from '../../../components/AppImage';

const ReferenceCodeLookup = () => {
  const [searchCode, setSearchCode] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [searching, setSearching] = useState(false);
  const [error, setError] = useState('');

  const mockProjects = [
  {
    referenceCode: 'EPX2025A1B2C3',
    createdAt: '2025-12-10T14:30:00',
    customerName: 'John Smith',
    customerEmail: 'john.smith@email.com',
    floorType: 'Metallic Epoxy',
    baseColor: 'Midnight Blue',
    baseColorHex: '#1e3a8a',
    flakeColor: 'Silver Sparkle',
    flakeColorHex: '#c0c0c0',
    room: 'Modern Garage',
    roomImage: "https://img.rocket.new/generatedImages/rocket_gen_img_193ee2927-1764798924046.png",
    roomImageAlt: 'Modern residential garage interior with white walls and concrete floor ready for epoxy coating application',
    intensity: 75,
    heaviness: 60,
    finish: 'Glossy'
  },
  {
    referenceCode: 'EPX2025D4E5F6',
    createdAt: '2025-12-12T10:15:00',
    customerName: 'Sarah Johnson',
    customerEmail: 'sarah.j@email.com',
    floorType: 'Flake Epoxy',
    baseColor: 'Charcoal Gray',
    baseColorHex: '#374151',
    flakeColor: 'Autumn Blend',
    flakeColorHex: '#d97706',
    room: 'Industrial Warehouse',
    roomImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1e6bc6891-1764865975781.png",
    roomImageAlt: 'Large industrial warehouse interior with high ceilings and concrete floor space for commercial epoxy flooring',
    intensity: 85,
    heaviness: 70,
    finish: 'Matte'
  }];


  const handleSearch = () => {
    setSearching(true);
    setError('');
    setSearchResult(null);

    setTimeout(() => {
      const result = mockProjects?.find(
        (p) => p?.referenceCode?.toLowerCase() === searchCode?.toLowerCase()
      );

      if (result) {
        setSearchResult(result);
      } else {
        setError('Reference code not found. Please check the code and try again.');
      }
      setSearching(false);
    }, 800);
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="Search" size={20} color="var(--color-primary)" />
        <h3 className="text-lg font-semibold text-text-primary">Reference Code Lookup</h3>
      </div>
      <div className="flex gap-2 mb-6">
        <Input
          type="text"
          placeholder="Enter reference code (e.g., EPX2025A1B2C3)"
          value={searchCode}
          onChange={(e) => setSearchCode(e?.target?.value?.toUpperCase())}
          onKeyPress={(e) => e?.key === 'Enter' && handleSearch()}
          error={error} />

        <Button
          variant="default"
          onClick={handleSearch}
          loading={searching}
          disabled={!searchCode?.trim()}
          iconName="Search"
          iconPosition="left"
          iconSize={16}>

          Search
        </Button>
      </div>
      {searchResult &&
      <div className="border border-border rounded-lg overflow-hidden">
          <div className="bg-muted p-4 border-b border-border">
            <div className="flex items-center justify-between">
              <div>
                <h4 className="text-lg font-semibold text-text-primary">
                  {searchResult?.referenceCode}
                </h4>
                <p className="text-sm text-text-secondary">
                  Created on {formatDate(searchResult?.createdAt)}
                </p>
              </div>
              <div className="px-3 py-1 bg-success/10 text-success text-xs font-medium rounded-full">
                Found
              </div>
            </div>
          </div>

          <div className="p-6 space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h5 className="text-sm font-medium text-text-secondary mb-3">Customer Information</h5>
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <Icon name="User" size={16} className="text-text-secondary" />
                    <span className="text-sm text-text-primary">{searchResult?.customerName}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="Mail" size={16} className="text-text-secondary" />
                    <span className="text-sm text-text-primary">{searchResult?.customerEmail}</span>
                  </div>
                </div>
              </div>

              <div>
                <h5 className="text-sm font-medium text-text-secondary mb-3">Floor Selection</h5>
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <Icon name="Grid3x3" size={16} className="text-text-secondary" />
                    <span className="text-sm text-text-primary">{searchResult?.floorType}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="Droplet" size={16} className="text-text-secondary" />
                    <span className="text-sm text-text-primary">{searchResult?.finish}</span>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h5 className="text-sm font-medium text-text-secondary mb-3">Color Selection</h5>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-center gap-3 p-3 bg-muted rounded-lg">
                  <div
                  className="w-12 h-12 rounded-lg border-2 border-border flex-shrink-0"
                  style={{ backgroundColor: searchResult?.baseColorHex }} />

                  <div>
                    <p className="text-xs text-text-secondary">Base Color</p>
                    <p className="text-sm font-medium text-text-primary">{searchResult?.baseColor}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-3 bg-muted rounded-lg">
                  <div
                  className="w-12 h-12 rounded-lg border-2 border-border flex-shrink-0"
                  style={{ backgroundColor: searchResult?.flakeColorHex }} />

                  <div>
                    <p className="text-xs text-text-secondary">Flake Color</p>
                    <p className="text-sm font-medium text-text-primary">{searchResult?.flakeColor}</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h5 className="text-sm font-medium text-text-secondary mb-3">Design Settings</h5>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-text-primary">Intensity</span>
                    <span className="text-sm font-medium text-text-primary">{searchResult?.intensity}%</span>
                  </div>
                  <div className="h-2 bg-muted rounded-full overflow-hidden">
                    <div
                    className="h-full bg-primary transition-all duration-300"
                    style={{ width: `${searchResult?.intensity}%` }} />

                  </div>
                </div>
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-text-primary">Heaviness</span>
                    <span className="text-sm font-medium text-text-primary">{searchResult?.heaviness}%</span>
                  </div>
                  <div className="h-2 bg-muted rounded-full overflow-hidden">
                    <div
                    className="h-full bg-secondary transition-all duration-300"
                    style={{ width: `${searchResult?.heaviness}%` }} />

                  </div>
                </div>
              </div>
            </div>

            <div>
              <h5 className="text-sm font-medium text-text-secondary mb-3">Room Preview</h5>
              <div className="relative rounded-lg overflow-hidden border border-border">
                <Image
                src={searchResult?.roomImage}
                alt={searchResult?.roomImageAlt}
                className="w-full h-64 object-cover" />

                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background/90 to-transparent p-4">
                  <p className="text-sm font-medium text-text-primary">{searchResult?.room}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {!searchResult && !error &&
      <div className="text-center py-12">
          <Icon name="Search" size={48} className="mx-auto mb-4 text-text-secondary opacity-50" />
          <p className="text-sm text-text-secondary">
            Enter a reference code to view project details
          </p>
        </div>
      }
    </div>);

};

export default ReferenceCodeLookup;